import { dataMember, typedArray } from 'santee-dcts';

export class ShipmentData {
    @dataMember()
    public shipmentId?: string;
    @dataMember()
    public airwayBillNumber?: string;
    @dataMember()
    public destinationOrgName?: string;
    @dataMember()
    public courierName?: string;
    @dataMember()
    public numberOfContainers?: number;
    @dataMember()
    public dateCreated?: string;
    @dataMember()
    public action?: string;
    @dataMember()
    public dateSubmitted?: string;
    @dataMember()
    public protocolCode?: string;
    @dataMember()
    public resumeAction?: string;
    @dataMember()
    public reviewAction?: string;
    @dataMember()
    public deleteAction?: string;
    @dataMember()
    public hasPermission?: boolean;
    @dataMember()
    public investigatorSiteShipmentContainerId?: number;
    @dataMember()
    public shipmentStatus?: string;
    @dataMember()
    public lgxCourierShipmentId?: string;
    @dataMember()
    public createdBy?: string;
    public rowSelected?: boolean;
    public disableAction?: boolean;
}

export class SiteShippingInProgressModel {
    @dataMember()
    @typedArray(ShipmentData)
    public inProgressData: ShipmentData[];
}

export interface WayBillValidatorData {
    waybillNumber: string;
    courierName: string;
    submittedDate?: string;
}

export class WayBillValidatorDataModel {
    @dataMember()
    @typedArray(ShipmentData)
    public waybillValidatorData: WayBillValidatorData[];
}